import React from "react";
import { useTheme } from "arkh";
import { AHSegmentedControl } from "./mobile/AHSegmentedControl";
import { SegmentedControlProps } from "@react-native-segmented-control/segmented-control";

export function SegmentedControl(props: SegmentedControlProps) {
  const theme = useTheme();
  return (
    <AHSegmentedControl
      appearance="light"
      style={{
        backgroundColor: theme["surface-backgroundControl"],
      }}
      fontStyle={{
        color: theme["text-primary"],
      }}
      activeFontStyle={{
        color: theme["text-inverted"],
      }}
      backgroundColor={theme["surface-background"]}
      tintColor={theme["status-active"]}
      {...props}
    />
  );
}
